module.exports = __webpack_public_path__ + "static/media/5_fanout_to_multifiber_B_yellow_square.5e9132ba.png";